import React from 'react';
import PropTypes from 'prop-types';
import RadioOption from './radio-option.jsx';

/**
 * Renders a list of radio input options.
 */
const RadioOptionList = ({ options, selectedOptionId, textToBold, selectionHandler }) => {
  return Object.entries(options).map(option => {
    const [id, { label, disabled }] = option;

    const sanitizedSelectedOptionId = selectedOptionId ? sanitizeId(selectedOptionId) : null;
    const sanitizedId = sanitizeId(id);

    const checked = sanitizedSelectedOptionId === sanitizedId;

    return (
      <RadioOption
        key={sanitizedId}
        id={sanitizedId}
        name={label}
        textToBold={textToBold}
        disabled={disabled ?? false}
        checked={checked}
        clickHandler={() => selectionHandler(id)}
      />
    )
  })
};

const sanitizeId = (id) => id.replaceAll(' ', '-').toLowerCase();

RadioOptionList.propTypes = {
  /**
   * the options to display to the user for selection
   *
   * @example
   * {
   *  'primary-care': {
   *    label: 'Primary Care',
   *    disabled: false,
   *  },
   *  'oncology': {
   *    label: 'Oncology',
   *    disabled: true,
   *  },
   *  'behavioral-health': {
   *    label: 'Behavioral Health',
   *    disabled: false,
   *  },
   * }
   */
  options: PropTypes.object.isRequired,
  /**
   * the ID of the currently selected filter option
   */
  selectedOptionId: PropTypes.string,
  /**
   * the text to show in bolded font, when matched
   */
  textToBold: PropTypes.string,
  /**
   * the callback function for when a selection is made
   */
  selectionHandler: PropTypes.func.isRequired,
};

export default RadioOptionList;
